import * as React from "react";
import { useState, useEffect } from "react";

const PageFooter = () => {
  const [buildInfo, setBuildInfo] = useState({ version: 'dev', buildTime: 'development' });
  
  useEffect(() => {
    // Fetch build info from public folder
    fetch('/build-info.json')
      .then(res => res.json())
      .then(data => setBuildInfo(data))
      .catch(() => {
        // Fallback for development
        setBuildInfo({ 
          version: 'dev', 
          buildTime: 'development'
        });
      });
  }, []);
  
  return (
    <div className="page-footer">
      <div className="footer-body">
        <span 
          style={{ color: '#74797E', fontSize: '12px', paddingTop: '10px', display: 'block' }}
          data-build-time={buildInfo.buildTime}
          data-build-date={buildInfo.buildDate}
        >
          v{buildInfo.version}
        </span>
        {/* <span>Copyright 2020</span> */}
        {/* <span>
          Design by{" "}
          <strong>
            <a href="https://kijo.co.uk/" target="_blank" style={{color: '#74797E'}}>
              KIJO
            </a>
          </strong>
        </span> */}
      </div>
    </div>
  );
};

export default PageFooter;
